module.exports = __webpack_public_path__ + "static/img/1_2.abcf1e83.png";